import React, { Component } from "react";
import { connect } from "react-redux";

import messagesService from "../../services/messagesService";
import { reset, change } from "redux-form";
import { createMessage } from "../../store/messages";
import { generateInput } from "../utils/misc";

import { Button, Icon, Segment } from "semantic-ui-react";
import { Button as MaterialUIButton } from "@material-ui/core";
import { Picker, emojiIndex } from "emoji-mart";

import "emoji-mart/css/emoji-mart.css";

import Form from "../utils/Form";
import FileModal from "./FileModal";

class MessagesForm extends Component {
    state = { modalOpen: false, emojiPickerShow: false, lastMessage: "" };

    fields = () => [
        generateInput({
            name: "message",
            autoComplete: "on",
            placeholder: "send message",
            disabled: !this.props.currentChannel,
            formNoValidate: true,
            onInput: this.onInput,
        }),
    ];

    onInput = ({ target: { value } }) => {
        const { currentChannel, currentUser } = this.props;

        messagesService.updateTyping(!!value, currentChannel.id, { id: currentUser.uid, name: currentUser.displayName });
    };

    onModalOpen = () => this.setState({ modalOpen: true });

    onModalClose = () => this.setState({ modalOpen: false });

    toggleEmojiPicker = () => this.setState({ emojiPickerShow: !this.state.emojiPickerShow });

    colonToUnicode = message => {
        return message.replace(/:[A-Za-z0-9_+-]+:/g, x => {
            x = x.replace(/:/g, "");

            let emoji = emojiIndex.emojis[x];

            if (typeof emoji !== "undefined") {
                let unicode = emoji.native || emoji["1"]?.native;

                if (typeof unicode !== "undefined") return unicode;
            }

            x = ":" + x + ":";

            return x;
        });
    };

    selectEmoji = emoji => {
        this.props.change(
            "createMessage",
            "message",

            ` ${this.state.lastMessage || ""} ${emoji.native} `,
            // this.colonToUnicode(` ${this.state.lastMessage || ""} ${emoji.colons} `),
        );
    };

    onSubmit = async (formValues, content, cleanup) => {
        const { createMessage, currentChannel, currentUser } = this.props;

        if (!currentChannel) return;

        await createMessage({
            channel: { id: currentChannel.id, channelName: currentChannel.channelName },
            user: { id: currentUser.uid, name: currentUser.displayName, avatar: currentUser.photoURL },
            timestamp: messagesService.getTimestamp,
            [content]: formValues[content],
        });

        messagesService.updateTyping(false, currentChannel.id, { id: currentUser.uid, name: currentUser.displayName });

        cleanup();
    };

    render() {
        const { modalOpen, emojiPickerShow } = this.state;
        const { currentChannel, reset, isPrivateChannel } = this.props;

        return (
            <Segment className="messages-form">
                {emojiPickerShow && (
                    <Picker set="apple" title="pick your emoji" emoji="point_up" onSelect={this.selectEmoji} />
                )}

                <div className="form-container">
                    <div className="form-wrapper">
                        <Form
                            form="createMessage"
                            fields={this.fields()}
                            onSubmit={formValues =>
                                this.onSubmit(formValues, "message", () => {
                                    reset("createMessage", "message");

                                    this.setState({ lastMessage: "", emojiPickerShow: false });
                                })
                            }
                            onChange={({ message }) => this.setState({ lastMessage: message?.trim() })}>
                            <MaterialUIButton type="submit" className="submit-btn" disabled={!currentChannel}>
                                send
                            </MaterialUIButton>

                            {currentChannel && (
                                <Icon
                                    className="emoji-picker-btn"
                                    name="smile outline"
                                    size="large"
                                    onClick={this.toggleEmojiPicker}
                                />
                            )}
                        </Form>
                    </div>
                </div>

                <Button.Group className="actions">
                    <Button
                        content="upload media"
                        labelPosition="right"
                        icon="cloud upload"
                        disabled={!currentChannel}
                        onClick={this.onModalOpen}
                    />

                    <FileModal
                        modalOpen={modalOpen}
                        closeModal={this.onModalClose}
                        onSubmit={this.onSubmit}
                        isPrivateChannel={isPrivateChannel}
                    />
                </Button.Group>
            </Segment>
        );
    }
}

export default connect(null, { createMessage, reset, change })(MessagesForm);
